let _args = {}
let _initialized = false

/**
 * Called if response is 401 status before rejecting promise
 */
function onUnauthorised(response, xhr) {
  if (typeof _args.onUnauthorised === 'function') {
    _args.onUnauthorised()
  }
}

/**
 * Called if response is 403 status before rejecting promise
 */
function onForbidden(response, xhr) {
  if (typeof _args.onForbidden === 'function') {
    _args.onForbidden()
  }
}

/**
 * Called if response is 429 status before rejecting promise
 */
function onRateLimitExceeded(response, xhr) {
  if (typeof _args.onRateLimitExceeded === 'function') {
    _args.onRateLimitExceeded()
  }
}

/**
 * Called if response is 5** status before rejecting promise
 */
function onServerError(response, xhr) {
  if (typeof _args.onServerError === 'function') {
    _args.onServerError()
  }
}

function onServerOk(response, xhr) {
  if (typeof _args.onServerOk === 'function') {
    _args.onServerOk()
  }
}

/**
 * Called before making any request
 */
function onStart() {
  if (typeof _args.onStart === 'function') {
    _args.onStart()
  }
}

/**
 * Called After making request
 */
function onFinish() {
  if (typeof _args.onFinish === 'function') {
    _args.onFinish()
  }
}

/**
 * add an authorisation header to headers object
 */
function setAuthHeader(headers) {
  if (typeof _args.getAuthToken === 'function') {
    let token = _args.getAuthToken()

    headers.authorization = `Bearer: ${token}`
  }
}

/**
 * turn pagination object into url params
 *
 * @param url {string} - the request url
 * @param args {object} - pagination params object
 *
 * @returns {string}
 */
function handlePaginationParams(url, args) {
  if (!args) return ''

  let params = Object.keys(args)
    .map((key) => {
      return `${key}=${args[key]}`
    })
    .join('&')

  return url.includes('?') ? `&${params}` : `?${params}`
}

export default {
  /**
   * Initialize / configure ajax requests
   *
   * @param args
   * @param args.request {function} - makes the ajax request, returns a promise
   * @param args.urlBase {string} - base url for requests
   * @param args.getAuthToken {function} - getter for session token
   * @param args.onStart {function} - called before request starts
   * @param args.onFinish {function} - called after request finishes
   * @param args.onUnauthorised {function} - called on 401
   * @param args.onForbidden {function} - called on 403
   * @param args.onRateLimitExceeded {function} - called on 429
   * @param args.onServerError {function} - called on 5**
   * @param args.onServerOk {function} - called if no errors are present, to reset 5**
   */
  init(args) {
    _initialized = true
    _args = args
  },

  /**
   * Make a pagination params object
   *
   * @param number {integer} - page number
   * @param perPage {integer} - max results per page
   *
   * @returns {object} - new pagination params object
   */
  page(page, perPage) {
    return {
      page,
      page_size: perPage
    }
  },

  /**
   * Make an AJAX request
   *
   * Makes an AJAX request with domain specific behaviour added.
   *
   * @returns {Promise}
   */
  request(args) {
    if (!_initialized) {
      throw new Error('Ajax wrapper not initialized.')
    }

    return new Promise((resolve, reject) => {
      let pagination = handlePaginationParams(args.url, args.page)

      onStart()

      args.url = `${_args.urlBase}${args.url}${pagination}`
      args.type = args.type || 'JSON'

      if (args.data && args.type === 'JSON') {
        args.data = JSON.stringify(args.data)
      }

      if (!args.headers) {
        args.headers = {}
      }

      setAuthHeader(args.headers)

      _args
        .request(args)
        .then((xhr) => {
          let response = xhr.responseText ? JSON.parse(xhr.responseText) : {}
          let data = response.data
          let page = response.page

          onServerOk(response, xhr)
          resolve({data, page, xhr})
        })
        .catch((xhr) => {
          let response

          try {
            response = JSON.parse(xhr.responseText)
          } catch (e) {
            response = {}
          }

          if (xhr.status === 401) {
            onUnauthorised(response, xhr)
          } else if (xhr.status === 403) {
            onForbidden(response, xhr)
          } else if (xhr.status === 429) {
            onRateLimitExceeded(response, xhr)
          } else if (xhr.status >= 500) {
            onServerError(response, xhr)
          }

          reject({response, xhr})
        })
        .finally(() => {
          onFinish()
        })
    })
  }
}
